import { defineMessages } from 'react-intl';

export const wallet = defineMessages({
  enabled_succsessfully: {
    id: 'modules.Profile.Wallet.enabledSuccessfully',
    defaultMessage: 'Wallet has been successfully enabled!'
  },
  enable_wallet_description: {
    id: 'modules.Profile.Wallet.description',
    defaultMessage:
      'Enabling the Wallet is simple! You can add funds using your preferred payment method and start enjoying the full range of benefits the Wallet has to offer.'
  },
  generic_wallet_error: {
    id: 'error_generic_try_again',
    defaultMessage: 'Something went wrong. Please try again.'
  },
  enable_wallet: {
    id: 'enable',
    defaultMessage: 'Enable'
  },
  disable_wallet: {
    id: 'modules.Profile.Wallet.disable',
    defaultMessage: 'Disable wallet'
  },
  wallet_disabled: {
    id: 'modules.Profile.Wallet.disabled',
    defaultMessage: 'Wallet is disabled'
  },
  topup_initially: {
    id: 'modules.Profile.Wallet.chooseTopup',
    defaultMessage: 'Choose how much to topup with:'
  },
  topup_error: {
    id: 'error_generic_try_again',
    defaultMessage: 'Something went wrong. Please try again.'
  },
  continue: {
    id: 'components.buttons-i18n.continue',
    defaultMessage: 'Continue'
  },
  topup_sucsessfull: {
    id: 'modules.Profile.Wallet.topupSuccessful',
    defaultMessage: 'Topup successful!'
  },
  wallet_balance: {
    id: 'modules.Profile.Wallet.nowHas',
    defaultMessage: 'Your wallet now has {0}'
  },
  wallet_title: {
    id: 'modules.Profile.Wallet.title',
    defaultMessage: 'Wallet'
  },
  wallet_topup: {
    id: 'modules.Profile.Wallet.topUp',
    defaultMessage: 'Top up'
  },
  wallet_last_topup: {
    id: 'modules.Profile.Wallet.lastTopUpWas',
    defaultMessage: 'Your last top up was {0}'
  }
});
